import Columns from './Columns'
import Vue from 'vue'

let KendoGridColumn = {
    name: 'kendo-multicolumncombobox-column',
    render () {
        return Vue.prototype._e
    },
    mixins: [Columns]
}

export default KendoGridColumn


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoMultiColumnComboBox/KendoMultiColumnComboBoxColumn.js